module.exports = __webpack_public_path__ + "img/52.30090636.png";